import { Directive, HostBinding, Input } from "@angular/core";
import { isArray, orderBy as _sort } from "lodash";
import { CommonFormManagerDirective } from "../form-manager.directive";

@Directive({
    selector: "[template-presetter]",
    exportAs: "TemplatePresetter",
})
export class TemplatePresetterDirective {
    @Input() public formManager: CommonFormManagerDirective;
    @Input() public presetData: any;
    @Input() public partialPreset = true;
    @Input() public fieldProp: string;
    @Input() public partialInsertIndex;

    @HostBinding("class.u-hex-width-full")
    public fullWidth = true;

    public loadPresets(presetData?) {
        this.presetData = presetData || this.presetData;
        this.load();
    }

    private load() {
        if (this.data) {
            const finalData = isArray(this.data) ? _sort(this.data, ["name.length"]) : this.data;
            this.formManager.load(
                finalData,
                this.partialPreset,
                this.fieldProp,
                this.partialInsertIndex,
            );
        }
    }

    private get data() {
        return !!this.presetData && this.presetData.data ? this.presetData.data : undefined;
    }
}
